export default "__VITE_ASSET__BbmS2WKr__"